import { useQuery } from 'react-query';

export type Airlines = {
  iataCode: string;
  valid: boolean;
};

type RouteOptions = {
  selectedOrigin?: string;
  selectedDestination?: string;
  enableFilter?: boolean;
};

export type FetchAirlines = (options: RouteOptions) => Promise<Airlines[]>;

export function useAirlines(FetchAirlines: FetchAirlines, options: RouteOptions) {
  const key = `origin-${options.selectedOrigin}-destination-${options.selectedDestination}`;
  return useQuery(key, () => FetchAirlines(options), {
    refetchOnWindowFocus: false,
    staleTime: 86400000,
    enabled: options.enableFilter ?? false,
  });
}
